import React from 'react'
import {
  Modal as ChakraModal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks'

export const Modal = ({
  children,
  isOpen = false,
  onClose,
  headerText,
  closeOnEsc = true,
  closeOnOverlayClick = true,
}: {
  children: React.ReactNode
  isOpen: boolean
  onClose?: () => void
  headerText?: string
  closeOnEsc?: boolean
  closeOnOverlayClick?: boolean
}) => {
  const { isDesktop } = useDeviceType()
  return (
    <>
      <ChakraModal
        closeOnEsc={closeOnEsc}
        closeOnOverlayClick={closeOnOverlayClick}
        isOpen={isOpen}
        onClose={() => {
          if (onClose) { 
            onClose()
          }
        }}
      >
        <ModalOverlay />
        <ModalContent
          maxWidth={isDesktop ? 'fit-content' : '90%'}
          height='fit-content'
          rounded='2xl'
        >
          {headerText &&<ModalHeader borderBottom={'1px solid #ADADAD'} fontWeight={'medium'}>
            {headerText}
          </ModalHeader>}
          {onClose && <ModalCloseButton onClick={() => onClose()} />}
          
          {children}
        </ModalContent>
      </ChakraModal>
    </>
  )
}
